module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Abbreviations of Frequently Cited Works by Gershom Scholem"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253062093_Contents#rsec1"
    }
  }, [_vm._v("ABBREVIATIONS OF FREQUENTLY CITED WORKS BY GERSHOM SCHOLEM")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GERMAN")]), _c('sup', [_c('a', {
    attrs: {
      "id": "fna-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253062093_Abbreviations#rfna-1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('i', [_vm._v("Br I")]), _vm._v(", "), _c('i', [_vm._v("Br II")]), _vm._v(",")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("Briefe")]), _vm._v(". Edited by Itta Shedletzky and Thomas Sparr.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('i', [_vm._v("Br III")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_vm._v("3 vols. Munich: C. H. Beck, 1994–1999.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_c('i', [_vm._v("T I")]), _vm._v(", "), _c('i', [_vm._v("T II")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("Tagebücher nebst Äufsätzen und Entwürfen bis 1923")]), _vm._v(". Edited by Herbert Kopp-Oberstebrink, Karlfried Gründer, and Friedrich Niewöhner. 2 vols. Frankfurt: Suhrkamp, 1995–2000.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENGLISH")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("FBJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("From Berlin to Jerusalem: Memories of My Youth")]), _vm._v(". Translated by Harry Zohn. New York: Schocken Books, 1980.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("JJC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("On Jews and Judaism in Crisis: Selected Essays")]), _vm._v(". Edited by Werner J. Dannhauser. New York: Schocken Books, 1976.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("KS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("On the Kabbalah and Its Symbolism")]), _vm._v(". Translated by Ralph Manheim. New York: Schocken Books, 1969.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("LL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("A Life in Letters, 1914–1982")]), _vm._v(". Edited and translated by Anthony David Skinner. Cambridge, MA: Harvard University Press, 2002.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('i', [_vm._v("LY")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("Lamentations of Youth: The Diaries of Gershom Scholem, 1913–1919")]), _vm._v(". Edited and translated by Anthony David Skinner. Cambridge, MA: Harvard University Press, 2007.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("MI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("The Messianic Idea in Judaism and Other Essays on Jewish Spirituality")]), _vm._v(". New York: Schocken Books, 1971.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("MS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("On the Mystical Shape of the Godhead: Basic Concepts in the Kabbalah")]), _vm._v(". Translated by Joachim Neugroschel. Edited and revised by Jonathan Chipman. New York: Schocken Books, 1991.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("Major Trends in Jewish Mysticism")]), _vm._v(". New York: Schocken Books, 1961.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("PM")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("On the Possibility of Jewish Mysticism in Our Time and Other Essays")]), _vm._v(". Translated by Jonathan Chipman. Edited and selected with an introduction by Avraham Shapira. Philadelphia: The Jewish Publication Society, 1997.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("SS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "abb"
  }, [_c('i', [_vm._v("Sabbatai Sevi: The Mystical Messiah, 1626–1676")]), _vm._v(". Translated by R. J. Zwi Werblowsky. Princeton, NJ: Princeton University Press, 1973.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "note_para"
  }, [_c('a', {
    attrs: {
      "id": "rfna-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253062093_Abbreviations#fna-1"
    }
  }, [_vm._v("1")]), _vm._v(". Passages from Scholem’s letters and diaries that are not included in the English collections "), _c('i', [_vm._v("A Life in Letters")]), _vm._v(" and "), _c('i', [_vm._v("Lamentations of Youth")]), _vm._v(" have been translated from the German by Sage Anderson.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e1cf012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253062093_Abbreviations.vue
// module id = 72
// module chunks = 0